import { Link } from "react-router-dom";

export default function CTASection({ title, subtitle, buttonText, buttonLink }) {
  return (
    <section className="bg-[#336DBF] py-12 sm:py-16" data-testid="cta-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-2xl sm:text-3xl font-semibold text-white tracking-tight">
          {title || "Prêt à voir la différence ?"}
        </h2>
        {subtitle && <p className="mt-3 text-white/90 text-lg max-w-2xl mx-auto">{subtitle}</p>}
        <Link
          to={buttonLink || "/contact"}
          className="mt-6 inline-flex items-center justify-center px-8 py-4 bg-white text-[#336DBF] font-semibold rounded-md hover:bg-white/90 transition-colors text-base sm:text-lg"
          data-testid="cta-section-button"
        >
          {buttonText || "Demandez votre devis gratuit"}
        </Link>
      </div>
    </section>
  );
}
